import { render, staticRenderFns } from "./block-charge-way.vue?vue&type=template&id=8ca749f6&scoped=true&"
import script from "./block-charge-way.vue?vue&type=script&lang=js&"
export * from "./block-charge-way.vue?vue&type=script&lang=js&"
import style0 from "./block-charge-way.vue?vue&type=style&index=0&id=8ca749f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca749f6",
  null
  
)

export default component.exports